import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconViewTwoColumnsComponent } from "./med-icon-view-two-columns.component";

@NgModule({
  declarations: [
    MedIconViewTwoColumnsComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconViewTwoColumnsComponent,
  ],
})
export class MedIconViewTwoColumnsModule { }
